import { initializeApp } from "firebase/app";
import {
  createUserWithEmailAndPassword,
  getAuth,
  GoogleAuthProvider,
  sendEmailVerification,
  signInWithPopup,
  updateProfile,
} from "firebase/auth";
import {
  doc,
  getDoc,
  getFirestore,
  setDoc,
  Timestamp,
} from "firebase/firestore";
import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Link, useNavigate } from "react-router-dom";
import { firebaseConfig } from "../utils/firebaseConfig";
import { postRequest } from "../utils/functions";
import notificationSvc from "../utils/notificationSvc";
const SignUp = () => {
  const app = initializeApp(firebaseConfig);
  const db = getFirestore(app);
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [password, setPassword] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");

  const handleLogin = (e) => {
    e.preventDefault();
    const auth = getAuth();
    createUserWithEmailAndPassword(auth, email, password)
      .then(async (userCredential) => {
        sendEmailVerification(userCredential.user).then((res) => {
          updateProfile(userCredential.user, {
            displayName: firstName + " " + lastName,
          }).then(async () => {
            const customer = await postRequest("/user/register", {
              name: firstName + " " + lastName,
              email: email,
            });
            if (customer.status === 200) {
              const date = new Date();
              setDoc(doc(db, `Users`, userCredential.user.uid), {
                FirstName: firstName,
                LastName: lastName,
                Phone: userCredential.user.phoneNumber,
                Email: email,
                DateCreated: Timestamp.fromDate(date).toDate(),
                Roles: ["Customer"],
                DateOfBirth: Timestamp.fromDate(dateOfBirth).toString(),
                StripeCustomerID: customer.data.customer.id,
              }).then((res) => {
                navigate("/login");
              });
            }
          });
        });
      })
      .catch((error) => {
        handleError(error);
      });
  };

  const handleGoogleLogin = async () => {
    const auth = getAuth();
    const provider = new GoogleAuthProvider();
    provider.addScope("https://www.googleapis.com/auth/user.birthday.read");
    signInWithPopup(auth, provider)
      .then(async (response) => {
        const user = response.user;
        const ref = doc(db, `Users`, user.uid);
        const document = await getDoc(ref);
        if (document.exists()) {
          user.getIdToken().then((res) => {
            localStorage.setItem("token", res);
            localStorage.setItem(
              "user",
              JSON.stringify({
                ...user,
                StripeCustomerID: document.data().StripeCustomerID,
              })
            );
            navigate("/booking-details");
          });
        } else {
          // doc.data() will be undefined in this case
          const customer = await postRequest("/user/register", {
            name: user.displayName,
            email: user.email,
          });
          if (customer.status === 200) {
            const date = new Date();
            setDoc(doc(db, `Users`, user.uid), {
              FirstName: user.displayName.split(" ")[0],
              LastName: user.displayName.split(" ")[1],
              Phone: user.phoneNumber,
              DateOfBirth: Timestamp.fromDate(dateOfBirth).toDate(),
              Email: user.email,
              DateCreated: Timestamp.fromDate(date).toDate(),
              Roles: ["Customer"],
              StripeCustomerID: customer.data.customer.id,
            }).then((res) => {
              response.user.getIdToken().then((res) => {
                localStorage.setItem("token", res);
                localStorage.setItem(
                  "user",
                  JSON.stringify({
                    ...user,
                    StripeCustomerID: customer.data.customer.id,
                  })
                );
                navigate("/booking-details");
              });
            });
          }
        }
      })
      .catch((err) => {
        handleError(err);
      });
  };

  const handleError = (err) => {
    switch (err.code) {
      case "auth/invalid-email":
        notificationSvc.error("The email address you provided is invalid.");
        break;
      case "auth/user-disabled":
        notificationSvc.error(
          "The user account has been disabled by an administrator."
        );
        break;
      case "auth/user-not-found":
        notificationSvc.error(
          "There is no user record corresponding to the email address provided."
        );
        break;
      case "auth/wrong-password":
        notificationSvc.error("The password you provided is incorrect.");
        break;
      case "auth/email-already-in-use":
        notificationSvc.error(
          "The email address you provided is already in use by another account."
        );
        break;
      case "auth/account-exists-with-different-credential":
        notificationSvc.error(
          "An account already exists with the same email address but different sign-in credentials."
        );
        break;
      case "auth/popup-blocked":
        notificationSvc.error("The popup window was blocked by the browser.");
        break;
      case "auth/popup-closed-by-user":
        notificationSvc.error(
          "The user closed the popup window before completing the sign-in process."
        );
        break;
      default:
        notificationSvc.error("An unknown error occurred.");
        break;
    }
  };

  return (
    <div className="bg_img">
      <div className="container">
        <div className="row">
          <div className="col-md-6 mt-3  mb-3 offset-md-3">
            <div className="wrap-login100 p-5 mx-4">
              <form
                className="login100-form validate-form"
                onSubmit={(e) => handleLogin(e)}
              >
                <span className="login100-form-title pb-4 pt-4">Signup</span>
                <div className="row">
                  <div className="col-md-6">
                    <div
                      className="wrap-input100 validate-input mb-3"
                      data-validate="Email is required"
                    >
                      <span className="label-input100">First Name</span>
                      <input
                        className="input100"
                        type="text"
                        required
                        value={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                        name="username"
                        placeholder="Email"
                      />
                      <span className="focus-input100" data-symbol="" />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div
                      className="wrap-input100 validate-input mb-3"
                      data-validate="Email is required"
                    >
                      <span className="label-input100">Last Name</span>
                      <input
                        className="input100"
                        type="text"
                        required
                        value={lastName}
                        onChange={(e) => setLastName(e.target.value)}
                        name="username"
                        placeholder="Email"
                      />
                      <span className="focus-input100" data-symbol="" />
                    </div>
                  </div>
                </div>
                <div
                  className="wrap-input100 validate-input mb-3"
                  data-validate="Email is required"
                >
                  <span className="label-input100">Date of Birth</span>
                  <DatePicker
                    required
                    value={dateOfBirth}
                    onChange={(e) => setDateOfBirth(e)}
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    className="input100"
                  />
                  <span className="focus-input100" data-symbol="" />
                </div>
                <div
                  className="wrap-input100 validate-input mb-3"
                  data-validate="Email is required"
                >
                  <span className="label-input100">Email</span>
                  <input
                    className="input100"
                    type="email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    name="username"
                    placeholder="Email"
                  />
                  <span className="focus-input100" data-symbol="" />
                </div>
                <div
                  className="wrap-input100 validate-input  mb-3"
                  data-validate="Password is required"
                >
                  <span className="label-input100">Password</span>
                  <input
                    className="input100"
                    type="password"
                    value={password}
                    required
                    onChange={(e) => setPassword(e.target.value)}
                    name="pass"
                    placeholder="Password"
                  />
                  <span className="focus-input100" data-symbol="" />
                </div>
                {/* <div className="text-right pt-3 pb-3 text-end">
                    <Link href="#" className="login_a text-decoration txt1 ">
                      Forgot password?
                    </Link>
                  </div> */}
                <div className="container-login100-form-btn">
                  <div className="wrap-login100-form-btn">
                    <div className="login100-form-bgbtn" />
                    <button type="submit" className="login100-form-btn log_sub">
                      Signup
                    </button>
                  </div>
                </div>
              </form>
              <div className="txt1 text-center pt-5 pb-3">
                <span>Or Sign Up Using</span>
              </div>
              <div className="flex-c-m mb-4">
                <button
                  onClick={() => handleGoogleLogin()}
                  className="login100-social-item bg3 text-decoration"
                >
                  <i className="fa fa-google" />
                </button>
              </div>
              <div className="flex-col-c p-t-15">
                <span className="txt1 p-b-17">Or Already have an account?</span>
                <Link to="/login" className="txt2 text-decoration">
                  Login
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default SignUp;
